import React from 'react';
import { Divider } from '@ui-kitten/components';
import { StyleSheet, Text, ScrollView } from 'react-native';
import { Modal, luxColors, DNABox, DNAButton } from '../../../index';
import ToU from './ToU';
import Privacy from './Privacy';
const styles = StyleSheet.create({
    backdrop: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    buttonContainer: {
        marginTop: 12,
        marginLeft: 24,
        marginRight: 12,
        marginBottom: 12,
    },
    container: {
        marginHorizontal: 24,
        maxWidth: '1000',
        height: '85vh',
        width: '90vw',
        maxHeight: '600',
        backgroundColor: luxColors.confirmationBackground.primary,
        borderRadius: 6,
        borderWidth: 3,
        borderColor: luxColors.menuBorder.primary,
        shadowColor: luxColors.menuShadown.primary,
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
    },
    descriptionContainer: {
        flex: 1,
        marginTop: 30,
        marginLeft: 24,
        marginRight: 24,
        marginBottom: 24,
    },
    divider: {
        backgroundColor: luxColors.mainContainer.primary,
    },
    header: {
        marginLeft: 24,
        marginBottom: 10,
        fontWeight: 'bold',
        fontSize: 16,
        lineHeight: 24,
        color: luxColors.confirmationHeader.primary,
    },
    headerContainer: {
        marginRight: 20,
        marginTop: 10,
    },
});
export var MODE;
(function (MODE) {
    MODE["ToU"] = "ToU";
    MODE["Privacy"] = "Privacy";
})(MODE || (MODE = {}));
const Disclaimer = (props) => {
    function onClose() {
        props.onClose();
    }
    return (<Modal visible={true} backdropStyle={styles.backdrop} onBackdropPress={onClose}>
    <DNABox>
      <DNABox appearance="col" style={styles.container}>
        <DNABox appearance="row" spacing="between" style={styles.headerContainer}>
          <DNABox alignY="center">
            <Text style={styles.header}>{props.mode === MODE.ToU ? 'Terms of Use' : 'Privacy Policy'}</Text>
          </DNABox>
          <DNABox alignX="end" alignY="center">
            <DNAButton appearance="ghost" status="secondary" iconLeft="x" onPress={onClose}/>
          </DNABox>
        </DNABox>
        <Divider style={styles.divider}/>
        <DNABox style={styles.descriptionContainer}>
          <ScrollView>
            {props.mode === MODE.ToU ? <ToU /> : <Privacy />}
          </ScrollView>
        </DNABox>
        <Divider style={styles.divider}/>
        <DNABox appearance="row" alignX="end" style={styles.buttonContainer}>
          <DNAButton status={'primary'} onPress={onClose} children="Close"/>
        </DNABox>
      </DNABox>
    </DNABox>
  </Modal>);
};
export default Disclaimer;
//# sourceMappingURL=index.js.map